import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { getUserUrlPrefix } from '../../auth/selectors';
import withPermissions from '../../auth/utils/withPermissions';
import { canUserModifyBankAccounts, canUserViewBankAccounts } from '../helpers/users';
import withToggle from '../hoc/withToggle';
import { persistentKVStore } from '../../../modules/infra/persistence';

const mapStateToProps = state => ({
  bankAccount: state.settings.bankAccount,
  urlPrefix: getUserUrlPrefix(state),
});

const enhance = compose(
  withPermissions,
  withRouter,
  connect(mapStateToProps),
  withToggle('showModal', true),
  withProps(props => ({
    canModifyBankAccount: canUserViewBankAccounts(props.permissions) && canUserModifyBankAccounts(props.permissions),
  })),
  lifecycle({
    componentDidMount() {
      if (this.props.canModifyBankAccount) {
        this.props.getBankAccount(this.props.ownerId);
      }
    },
    componentDidUpdate(prevProps) {
      const userHasSwitched = this.props.ownerId !== prevProps.ownerId;
      const userBecomeAbleToModifyBankAccount = this.props.canModifyBankAccount
        && (this.props.canModifyBankAccount !== prevProps.canModifyBankAccount);

      if (userBecomeAbleToModifyBankAccount || (userHasSwitched && this.props.canModifyBankAccount)) {
        this.props.getBankAccount(this.props.ownerId);
      }
    },
  }),
  withProps((props) => {
    if (!props.bankAccount) {
      return { isModalVisible: false };
    }

    const bankAccountDetails = props.bankAccount.details;
    const legalEntity = props.bankAccount.details.legal_entity;

    const verificationDeadlines = [
      legalEntity.requirements.current_deadline,
      bankAccountDetails.requirements.current_deadline,
    ].filter(deadline => !!deadline);

    const verificationDeadline =
      verificationDeadlines.length > 0 ? Math.min(...verificationDeadlines) : null;

    const currentlyDueRequirements = [
      ...legalEntity.requirements.currently_due,
      ...bankAccountDetails.requirements.currently_due,
    ];

    const hasProblems = currentlyDueRequirements.length !== 0;
    const now = moment(new Date());
    const lastShownAtRaw = persistentKVStore.getItem('bankAccountsWarningLastShown');
    const shownMoreThanADayAgo = lastShownAtRaw
      ? moment.duration(now.diff(moment(lastShownAtRaw))).asHours() > 24
      : true;

    return {
      isModalVisible: props.showModalIsOn && hasProblems && shownMoreThanADayAgo,
      verificationDeadline,
    };
  }),
  withHandlers({
    onClose: props => () => {
      persistentKVStore.setItem('bankAccountsWarningLastShown', new Date().toISOString());
      props.showModalOff();
    },
  }),
  withHandlers({
    onFixClick: props => () => {
      props.onClose();
      props.router.push(`${props.urlPrefix}/settings/bank-account`);
    },
  })
);

export default enhance;
